
import xss from "xss"
//直播互动
Vue.component("live_interaction", {
    props: {
        user_info: {
            default: () => {
                return {}
            }
        },
        teacher_info: {
            default: {}
        },
        live_id: {
            type: String,
        },
        disabled: {
            type: Boolean,
            defaultf: false
        }
    },
    data() {
        return {
            list: [],
            textarea: null,
            deleteActiveIndex: null,
            popoverActive: false,
            deleteBtnTop: -100,
            currentSelect: {},
            loading: false,
            deleteLoading: false,
            ifLoadMore: true,//是否加载全部
            tipsText: '',
        }
    },
    computed: {
        ready() {
            return this.user_info && this.user_info.user_code && this.user_info.username && this.live_id
        },
        canDelete() {
            return this.user_info && ((this.user_info.roles.includes('admin_S1') || this.user_info.roles.includes('r_sys_manager') || this.user_info.roles.includes('r_course_manager') || this.user_info.roles.includes('r_second_manager')) || this.user_info.user_code == this.teacher_info.code)
        }
    },
    mounted() {
        const that = this
        this.$refs.scroll_box.addEventListener('scroll', function (e) {
            if (e && e.target && e.target.scrollTop <= 0) {
                that.loadMore(e)
            }
        }, true)
        that.loadMore()
        setInterval(() => {
            that.loadMore(null,true)
        }, 5000)

    },
    methods: {
        /**
         * 往上翻页
         */
        loadMore(e, getNew) {
            if(getNew && this.list.length){
                //轮询最新数据
                this.getList({ maxTime: new Date(this.list[this.list.length - 1].createDate).getTime() })
            }
            //获取最老数据时间前的数据
            if (this.list.length) {
                this.getList({ minTime: new Date(this.list[0].createDate).getTime() }, e)
            } else {
                //初始化获取数据
                this.getList()
            }
        },
        /**
         * 不传参数获取最新数据
         * @param query
         * @param size 默认20
         */
        getList(query, event) {
            const that = this
            if (this.loading || !this.live_id) return
            const { size, minTime, maxTime, page = 1 } = query || {}
            // if (minTime && !this.ifLoadMore) return
            let params = {
                page,
                liveId: this.live_id
            }
            if (size) params.size = size
            if (minTime) params.minTime = new Date(minTime).getTime()
            if (maxTime) params.maxTime = new Date(maxTime).getTime()
            // console.log(new Date(minTime).getHours(), new Date(minTime).getMinutes(), new Date(minTime).getSeconds())
            this.loading = true
            API.reqLiveInteractionList(params).then(res => {
                // console.log(res)
                if (res.status == 200) {
                    let arr = res.data.results || []
                    arr.reverse()
                    //获取的列表需倒序
                    if (minTime) {
                        //翻页
                        this.list = [...arr, ...this.list]
                        // arr.map(el=>this.list.unshift(el))
                        // arr.map(el=>this.list.push(el))
                        if (res.data.page * res.data.size >= res.data.total) {
                            //无更多数据
                            this.ifLoadMore = false
                            this.tipsText = this.$t('已加载全部')
                            setTimeout(() => {
                                that.tipsText = ''
                            }, 2000);
                        }
                        let bottom = 0
                        if (event) {
                            bottom = event.target.scrollHeight - event.target.scrollTop
                            this.$nextTick(() => {
                                this.$refs.scroll_box.scrollTo({ top: event.target.scrollHeight - bottom })
                            })
                        }
                    } else if (!query) {
                        //首次加载
                        this.list = [...this.list, ...arr];
                        this.$nextTick(() => {
                            //首次滚动不需要加动画
                            this.$refs.scroll_box.scrollTo({ top: this.$refs.scroll_box.scrollHeight, behavior: "instant" });
                        });
                        if (res.data.results.length < res.data.size) {
                            //无更多数据
                            this.ifLoadMore = false;
                            this.tipsText = this.$t('已加载全部')
                            setTimeout(() => {
                                that.tipsText = ''
                            }, 2000);
                        }
                    } else {
                        //发布了互动获取最新
                        this.list = [...this.list, ...arr]
                        this.$nextTick(() => {
                            //首次滚动不需要加动画
                            this.$refs.scroll_box.scrollTo({ top: this.$refs.scroll_box.scrollHeight, behavior: 'smooth' })
                        })
                    }

                    this.$emit('update', arr)

                    // 首次获取无数据
                    if (!arr.length && !query) {
                        this.ifLoadMore = false
                        this.tipsText = this.$t('暂无数据')
                    }
                }
                // console.log(this.list)
            }).finally(() => this.loading = false)
        },
        handlePublish() {
            console.log(this.user_info)
            const { user_code, nick_name } = this.user_info || {}
            if (!user_code || !nick_name || !this.live_id) return
            API.reqLiveInteractionAdd({ liveId: this.live_id, userCode: user_code, userName: nick_name, text: this.textarea }).then(res => {
                console.log(res)
                this.textarea = null
                let listParam = {}
                //有列表数据，取大于最新数据时间，无列表数据则获取最新20条
                if (this.list.length) listParam.maxTime = this.list[this.list.length - 1].createDate
                this.getList(listParam)
            })
        },
        handlContextmenu(e, item) {
            if (!this.canDelete) return
            // console.log(e.currentTarget.offsetTop)
            this.deleteBtnTop = e.currentTarget.offsetTop
            this.currentSelect = item
        },
        closeDeleteBtn() {
            this.deleteActiveIndex = null
            this.popoverActive = false
            this.deleteBtnTop = -100
        },
        deleteConfirm() {
            console.log(this.currentSelect)
            if (!this.currentSelect.id) return
            this.deleteLoading = true
            API.reqLiveInteractionDelete({ id: this.currentSelect.id }).then(res => {
                if (res.status == 200) {
                    this.closeDeleteBtn()
                    this.list = this.list.filter(el => el.id != this.currentSelect.id)
                }
            }).finally(() => {
                this.deleteLoading = false
            })
        },
        scrollToBottom() {
            this.$nextTick(() => {
                this.$refs.scroll_box.scrollTo({ top: this.$refs.scroll_box.scrollHeight, behavior: 'smooth' })
            })
        },
        handleInput(val){
            this.textarea = xss(val)
        }
    },
    template: `
      <div class="live_interaction">
          <div class="scroll_box" ref="scroll_box">
              <el-popover
                placement="bottom"
                width="160"
                v-model="popoverActive">
                <p>{{$t('确认删除当前言论？')}}</p>
                <div style="text-align: right; margin: 0">
                  <span @click="popoverActive = false" style="margin-right: 10px;color: var(--color-primary);cursor: pointer">{{$t('取消')}}</span>
                  <el-button type="primary" size="mini" @click="deleteConfirm" :loading="deleteLoading">{{$t('确定')}}</el-button>
                </div>
                  <template slot="reference">
                       <div class="delete_btn" :style="{top:deleteBtnTop + 'px'}">{{$t('删除言论')}}</div>
                  </template>
              </el-popover>
              <div class="list" @click="closeDeleteBtn">
                  <div class="item load_more" v-if="ifLoadMore">
                      <i class="el-icon-loading" v-if="loading"></i>
                      <span v-else @click="loadMore()">{{$t('加载更多')}}</span>
                  </div>
                  <div class="item" v-else-if="tipsText" style="justify-content: center;color: #999">{{$t('已加载全部')}}</div>
                  <div class="item" v-for="(item, i) in list" :key="item.id" @contextmenu.prevent="handlContextmenu($event,item)">
                      <span>{{item.userName}}：</span>
                      <span class="content">{{item.text}}</span>
                  </div>
              </div>
          </div>
          <div class="input">
              <el-input :disabled="!ready || disabled" type="textarea" :placeholder="$t('发一个友好的互动~')" v-model="textarea" maxlength="100" show-word-limit @change="handleInput"></el-input>
              <el-button type="primary" size="mini" @click="handlePublish" :disabled="!ready || disabled || !textarea">{{$t('发表')}}</el-button>
          </div>
      </div>
  `
})